import React from 'react';

export interface LabelProps {
  className?: string;
  label: string;
}

const IconSet: React.FC<LabelProps> = ({ label, ...props }) => {
  return <span {...props}>{label}</span>;
};

export default IconSet;
